import { useState, useCallback } from 'react';
import API_ROUTES from './apiRoutes';

interface UseForgotPasswordReturn {
  sendRecoveryEmail: (email: string) => void;
  success: boolean;
  loading: boolean;
  error: string | null;
}

export const useForgotPassword = (): UseForgotPasswordReturn => {
  const [success, setSuccess] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const sendRecoveryEmail = useCallback(async (email: string) => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(API_ROUTES.AUTH.passwordRecovery(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Erro ao enviar email de recuperação');
      }

      setSuccess(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao enviar email de recuperação. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }, []);

  return { sendRecoveryEmail, success, loading, error };
};
